module.exports = __webpack_public_path__ + "img/shogi_2021_pack_4_0007.88f41263.png";